import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  ChatSquareTextFill,
  MicFill,
  MicMuteFill,
  SkipEndFill,
} from 'react-bootstrap-icons';
import {
  stopSpeaking,
  setShowTranscript,
  setMicOn,
} from '../store/sm/index';
import { primaryAccent } from '../globalStyle';
import FeedbackModal from './FeedbackModal';

function Controls({ className }) {
  const {
    micOn,
    speechState,
    showTranscript,
    transcript,
    requestedMediaPerms,
    highlightMic,
    highlightChat,
    highlightSkip,
  } = useSelector((state) => ({ ...state.sm }));

  const dispatch = useDispatch();
  const [showFeedback, setShowFeedback] = useState(false);

  // Disable mic and transcription by default on component load
  useEffect(() => {
    dispatch(setMicOn({ micOn: false }));
    dispatch(setShowTranscript(false));
  }, [dispatch]);

  // Toggle transcription and mic
  const toggleKeyboardInput = () => {
    dispatch(setShowTranscript(!showTranscript));
    dispatch(setMicOn({ micOn: showTranscript }));
  };

  const iconSize = 24;

  return (
    <div className={className}>
      {showFeedback && (
        <div className="alert-modal">
          <div className="alert-modal-card container">
            <FeedbackModal
              onClose={() => setShowFeedback(false)}
              closeText="Resume Conversation"
              denyFeedbackText="Close"
              denyFeedback={() => setShowFeedback(false)}
            />
          </div>
        </div>
      )}
      <div className="d-flex">
        <div>
          {/* Skip through whatever DP is currently speaking */}
          <button
            type="button"
            style={{
              padding: '10px',
              borderRadius: '30px',
              color: '#000',
            }}
            className="control-icon"
            disabled={speechState !== 'speaking'}
            onClick={() => dispatch(stopSpeaking())}
            data-tip="Skip Speech"
            aria-label="Skip Speech"
          >
            <SkipEndFill size={iconSize} style={{ border: highlightSkip ? 'red 2px solid' : '' }} />
          </button>
        </div>
        <div>
          {/* Show transcript */}
          <button
            type="button"
            style={{
              background: '#b5b5b5',
              padding: '10px',
              borderRadius: '30px',
              color: '#fff',
              margin: '0px 10px',
            }}
            className="control-icon"
            aria-label="Toggle Transcript"
            data-tip="Toggle Transcript"
            onClick={toggleKeyboardInput}
            disabled={transcript.length <= 0}
          >
            <ChatSquareTextFill
              size={iconSize}
              color={showTranscript ? primaryAccent : '#fff'}
              style={{ border: highlightChat ? 'red 2px solid' : '' }}
            />
          </button>
        </div>
        <div>
          {/* Toggle user mic */}
          <button
            style={{
              background: 'red',
              padding: '10px',
              borderRadius: '30px',
              color: '#fff',
            }}
            type="button"
            className="control-icon"
            aria-label="Toggle Microphone"
            data-tip="Toggle Microphone"
            disabled={requestedMediaPerms.micDenied === true}
            onClick={() => dispatch(setMicOn({ micOn: !micOn }))}
          >
            {micOn ? (
              <MicFill size={iconSize} color={primaryAccent} style={{ border: highlightMic ? 'red 2px solid' : '' }} />
            ) : (
              <MicMuteFill size={iconSize} style={{ border: highlightMic ? 'red 2px solid' : '' }} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

Controls.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(Controls)`
  /* Add styles here */
  .context-controls {
    position: absolute;
    z-index: 100;
    background: rgba(0,0,0,0.3);
    left: 0;
    top: 0;

    &>div {
      width: 100vw;
      height: 100vh;

      margin-top: 4rem;
    }

    ul {
      padding: 1rem;

      list-style-type: none;

      background: #FFF;
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 5px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;

      &>li {
        border-bottom: 1px solid rgba(0,0,0,0.4);
        padding: 0.5rem;
      }
      &>li:last-child {
        border: none;
        padding-bottom: 0;
      }
    }
  }
  .context-controls-trigger {
    position: relative;
    border: 1px solid red;
    z-index: 105;
  }
  .control-icon {
    border: none;
    background: none;

    padding: .4rem;
  }
  .form-control {
    opacity: 0.8;
    &:focus {
      opacity: 1;
    }
  }

  .interrupt {
    opacity: 1;
    transition: opacity 0.1s;
  }
  .interrupt-active {
    opacity: 0;
  }
  }
  .alert-modal {
    position: absolute;
    z-index: 1000;
    display: flex;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    background: rgba(0,0,0,0.3);
  }
  .alert-modal-card {
    background: #FFF;
    padding: 1.3rem;
    border-radius: 5px;
  }
`;
